import type {WorkspaceSnapshot,WorkspaceChatItem} from '@reados/contracts';
import {closeTab,emptyTabs,openTab,type TabState} from './workspace-context';

export interface QuickChatFrame {x:number;y:number;width:number;height:number}
export function constrainQuickChatFrame(frame:QuickChatFrame,viewport:{width:number;height:number}):QuickChatFrame{
 const maxWidth=Math.max(1,viewport.width-24),maxHeight=Math.max(1,viewport.height-24);
 const width=Math.max(Math.min(520,maxWidth),Math.min(Number.isFinite(frame.width)?frame.width:520,maxWidth));
 const height=Math.max(Math.min(420,maxHeight),Math.min(Number.isFinite(frame.height)?frame.height:700,maxHeight));
 return {width,height,x:Math.max(12,Math.min(Number.isFinite(frame.x)?frame.x:12,viewport.width-width-12)),y:Math.max(12,Math.min(Number.isFinite(frame.y)?frame.y:12,viewport.height-height-12))};
}

/** Migrate only explicitly marked Quick Chats out of ordinary Readex tabs. */
export function detachQuickChatTabs(tabs:TabState,quickIds:string[]):TabState{
 const next=quickIds.reduce((state,id)=>state.ids.includes(id)?closeTab(state,id):state,tabs);
 return next.ids.length?next:openTab({...emptyTabs,split:tabs.split},'pending');
}

/** Floating chats participate in context without taking a main-pane slot. */
export function withQuickChatWindows(snapshot:WorkspaceSnapshot,openIds:string[],sendingQuickChatId?:string):WorkspaceSnapshot{
 const focused=sendingQuickChatId?{tabId:sendingQuickChatId,threadId:sendingQuickChatId}:snapshot.chat.focused;
 const seen=new Set(focused?[focused.threadId]:[]),visible:WorkspaceChatItem[]=[],hidden:WorkspaceChatItem[]=[];
 const append=(target:WorkspaceChatItem[],item:WorkspaceChatItem)=>{if(!seen.has(item.threadId)){seen.add(item.threadId);target.push(item);}};
 if(snapshot.chat.focused)append(visible,snapshot.chat.focused);
 for(const item of snapshot.chat.visible)append(visible,item);
 for(const id of openIds)append(visible,{tabId:id,threadId:id});
 for(const item of snapshot.chat.open_but_not_visible)append(hidden,item);
 const content=sendingQuickChatId&&snapshot.content.focused?{...snapshot.content,focused:null,visible:[snapshot.content.focused,...snapshot.content.visible]}:snapshot.content;
 return {...snapshot,content,chat:{current:sendingQuickChatId?focused:snapshot.chat.current,focused,visible,open_but_not_visible:hidden}};
}
